import * as React from 'react'
import styled from 'react-emotion'
import { styleguide } from 'styleguide'
import BarSvg from './BarSvg'
import ApiSvg from './ApiSvg'
import SurveySvg from './SurveySvg'

const Icon = styled.div`
  height: 80px;
  width: 80px;
  ${styleguide.shadows.button};
  border-radius: ${styleguide.radii.outer};
  z-index: 2;
  overflow: hidden;
  position: relative;
  background-color: ${styleguide.colors.background};
`

const Svg = ({ name }) => {
  return name === 'bar' ? (
    <BarSvg />
  ) : name === 'api' ? (
    <ApiSvg />
  ) : (
    <SurveySvg />
  )
}

export default ({ icon, ...props }) => (
  <Icon {...props}>
    <Svg name={icon} />
  </Icon>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Icon/index.jsx